"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/PYFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_192)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_192`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V23.9998H-6V0.000244141Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0.000244141H30V8.00006H-6V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 15.9999H30V23.9998H-6V15.9999Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.3611 9.23938L13.4757 10.1248C13.8533 10.5025 14.087 11.0242 14.087 11.6005C14.087 12.753 13.1526 13.6874 12.0001 13.6874C10.8475 13.6874 9.91321 12.753 9.91321 11.6005C9.91321 11.0243 10.1468 10.5025 10.5244 10.1248L9.63906 9.23938C9.03479 9.84365 8.66101 10.6784 8.66101 11.6004C8.66101 13.4446 10.1559 14.9395 12.0001 14.9395C13.8442 14.9395 15.3392 13.4446 15.3392 11.6004C15.3392 10.6785 14.9654 9.84365 14.3611 9.23938Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0001 10.3484L12.3109 11.305H13.3167L12.503 11.8962L12.8138 12.8527L12.0001 12.2615L11.1863 12.8527L11.4972 11.8962L10.6835 11.305H11.6892L12.0001 10.3484Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_192`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as PYFlag };
